import { http } from "./http";
import type { DisputeView, TrackHistoryUpload } from "../types/disputes";

const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };

// Chargebacks: the evidence page and the track-history uploads that answer them.
export const disputesApi = {
  get: (id: string) => http.get<DisputeView>(`/disputes/${id}`),
  upload: (id: string, file: FormData) => http.post<unknown>(`/disputes/${id}/upload`, file, MULTIPART),
  /** Evidence for every disputed order in one payout. */
  uploadForPayout: (batchId: string, file: FormData) =>
    http.post<TrackHistoryUpload>(`/disputes/upload-for-payout/${batchId}`, file, MULTIPART),
};
